import React from 'react';
// @ts-ignore
import scss from "../sectionObject.module.scss";
import {formatInternationalPhoneNumber} from "../../helpers";

const SectionObjectPreview = ({data, planningState, dataAgent, objectPlanHandler, getDetails, slideIndex}) => {

    const agentFields = {
        name: dataAgent?.name,
        phone: dataAgent?.phone,
        email: dataAgent?.email,
    }

    return (
        <div className={`${scss.sectionObject}`}>
            {
                data.apartments.map((el, index) => {

                    const flatPreview = el.flat_plan_image?.links?.preview;
                    const floorPreview = el.floor_plan_image?.links?.preview;
                    const largeImageFlat = el.flat_plan_image?.links?.large;
                    const largeImageFloor = el.floor_plan_image?.links?.large;

                    return (
                        <React.Fragment key={index}>
                            <h4 className={scss.sectionObject__title}>
                                {el.type.name} {el.total_area} м²
                            </h4>

                            <div className={scss.sectionObject__content}>
                                <div className={scss.sectionObject__planning}>
                                    <div className={scss.sectionObject__planLabel}
                                         style={{
                                             backgroundImage: `url(${
                                                 planningState === 'Планировка' ? largeImageFlat : largeImageFloor
                                             })`,
                                             backgroundSize: "cover",
                                             backgroundRepeat: "no-repeat",
                                             backgroundPosition: "center center",
                                         }}>
                                    </div>
                                    <span className={scss.sectionObject__planTag}>
                                            {planningState}
                                        </span>
                                    <div className={scss.sectionObject__planToggle}>
                                        {flatPreview && (
                                            <div className={`${scss.sectionObject__planToggleItem} ${
                                                planningState === 'Планировка' ? scss.sectionObject__planToggleItemActive : ''
                                            }`}
                                                 onClick={objectPlanHandler}
                                            >
                                                <div
                                                    className={scss.sectionObject__planToggleItemImage}
                                                    id="flat_plan"
                                                    style={{
                                                        backgroundImage: `url(${flatPreview})`,
                                                        backgroundSize: "cover",
                                                        backgroundRepeat: "no-repeat",
                                                        backgroundPosition: "center center",
                                                    }}
                                                >

                                                </div>
                                            </div>
                                        )}

                                        {floorPreview && (
                                            <div className={`${scss.sectionObject__planToggleItem} ${
                                                planningState === 'Поэтажный план' ? scss.sectionObject__planToggleItemActive : ''
                                            }`}
                                                 onClick={objectPlanHandler}
                                            >
                                                <div
                                                    className={scss.sectionObject__planToggleItemImage}
                                                    id="flat_floor"
                                                    style={{
                                                        backgroundImage: `url(${floorPreview})`,
                                                        backgroundSize: "cover",
                                                        backgroundRepeat: "no-repeat",
                                                        backgroundPosition: "center center",
                                                    }}
                                                >

                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className={scss.sectionObject__info}>
                                    <div className={scss.objectDetails}>
                                        {getDetails(el).map((item, idx) => (
                                            <div key={idx} className={scss.objectDetailRow}>
                                                    <span className={scss.objectDetailLabel}>
                                                      <img className={scss.objectDetailLabelIcon} src={item.icon}
                                                           alt={item.label}/>
                                                      <p className={scss.objectDetailLabelText}>{item.label}</p>
                                                    </span>

                                                {item.isList ? (
                                                    <ul className={scss.objectDetailList}>
                                                        {item.value.map((listItem, i) => (
                                                            <li
                                                                className={`${scss.objectDetailValue} ${item.bold ? scss.objectDetailValueBold : ''}`}
                                                                key={i}
                                                            >
                                                                {listItem}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <span
                                                        className={`${scss.objectDetailValue} ${item.bold ? scss.objectDetailValueBold : ''}`}>
                                                            {item.value}
                                                        </span>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>

                            <div className={scss.sectionObject__footer}>
                                <ul className={scss.sectionObject__list}>
                                    {dataAgent && Object.entries(agentFields).map(([key, value]) => (
                                        value && (
                                            <li
                                                key={key}
                                                className={`
                                                        ${scss.sectionObject__listItem} 
                                                        ${key === 'name' ? scss.sectionObjectValueBold : ''}
                                                    `}
                                            >
                                                {
                                                    key === 'phone' ? formatInternationalPhoneNumber(value, 'RU') : value
                                                }
                                            </li>
                                        )
                                    ))}
                                </ul>
                                <span className={scss.sectionObject__countPage}>{slideIndex}</span>
                            </div>
                        </React.Fragment>
                    )
                })
            }
        </div>
    );
};

export default SectionObjectPreview;